import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./CareersJobOpenings.css";
import neridLogo from "../../../assets/logo/nLogoTrans.png"

const allJobs = [
  {
    id: 1,
    companyName: "NeridTech",
    jobTitle: "ASIC RTL Design Engineer",
    jobType: "Full Time",
    location: "Belgrade",
    postedDate: "20/Mar/2025",
    expired: true,
    logoUrl: neridLogo,
  },
  {
    id: 2,
    companyName: "NeridTech",
    jobTitle: "UVM Verification Engineer",
    jobType: "Full Time",
    location: "Belgrade",
    postedDate: "18/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
  {
    id: 3,
    companyName: "NeridTech",
    jobTitle: "IP Development Specialist",
    jobType: "Contract",
    location: "Belgrade",
    postedDate: "15/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
  {
    id: 4,
    companyName: "NeridTech",
    jobTitle: "SoC Integration Engineer",
    jobType: "Full Time",
    location: "Belgrade",
    postedDate: "12/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
  {
    id: 5,
    companyName: "NeridTech",
    jobTitle: "Low-Power Design Lead",
    jobType: "Full Time",
    location: "Belgrade",
    postedDate: "10/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
  {
    id: 6,
    companyName: "NeridTech",
    jobTitle: "Functional Verification Engineer",
    jobType: "Part Time",
    location: "Belgrade",
    postedDate: "08/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
  {
    id: 7,
    companyName: "NeridTech",
    jobTitle: "Formal Verification Specialist",
    jobType: "Contract",
    location: "Belgrade",
    postedDate: "05/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
  {
    id: 8,
    companyName: "NeridTech",
    jobTitle: "Regression Testing Engineer",
    jobType: "Full Time",
    location: "Belgrade",
    postedDate: "01/Mar/2025",
    expired: true,
    logoUrl: "https://via.placeholder.com/32?text=NT",
  },
];

export default function CareersJobOpenings() {
  const [keywords, setKeywords] = useState("");
  const [jobType, setJobType] = useState("");
  const [location, setLocation] = useState("");
  const [jobs, setJobs] = useState(allJobs);

  const handleSearch = () => {
    const kw = keywords.toLowerCase().trim();
    setJobs(
      allJobs.filter((job) => {
        const matchKw =
          job.jobTitle.toLowerCase().includes(kw) ||
          job.companyName.toLowerCase().includes(kw);
        const matchType = jobType ? job.jobType === jobType : true;
        const matchLoc = location ? job.location === location : true;
        return matchKw && matchType && matchLoc;
      })
    );
  };

  return (
    <section className="careers-job-openings">
      <div className="search-bar">
        <div className="field-with-icon">
          <i className="fas fa-search icon" />
          <input
            type="text"
            placeholder="Search any keywords"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
          />
        </div>
        <div className="field-with-icon">
          <i className="fas fa-briefcase icon" />
          <select
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
          >
            <option value="">All Job Types</option>
            <option>Full Time</option>
            <option>Part Time</option>
            <option>Contract</option>
            <option>Remote</option>
          </select>
        </div>
        <div className="field-with-icon">
          <i className="fas fa-map-marker-alt icon" />
          <select
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          >
            <option value="">All Locations</option>
            <option>Belgrade</option>
          </select>
        </div>
        <button className="search-btn" onClick={handleSearch}>
          Search
        </button>
      </div>

      <div className="job-list">
        {jobs.map((job) => (
          <div key={job.id} className="job-item">
            <div className="job-logo">
              <img src={neridLogo} alt={job.companyName} />
            </div>
            <div className="job-content">
              <div className="job-title">{job.jobTitle}</div>
              <span className="job-type">{job.jobType}</span>
              <div className="job-details">
                <span className="job-location">{job.location}</span>
                <span className="job-posted-date">{job.postedDate}</span>
              </div>
            </div>
            <button className="apply-btn expired" disabled>
              Expired
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}